import { Editor, isTextSelection } from "@tiptap/core";
import BubbleMenu from "@tiptap/extension-bubble-menu";
import FileHandler from "@tiptap/extension-file-handler";
import Image from "@tiptap/extension-image";
import { TaskItem, TaskList } from "@tiptap/extension-list";
import { Table, TableCell, TableHeader, TableRow } from "@tiptap/extension-table";
import TextAlign from "@tiptap/extension-text-align";
import Youtube from "@tiptap/extension-youtube";
import { CharacterCount, Placeholder } from "@tiptap/extensions";
import StarterKit from "@tiptap/starter-kit";
import Tiktok, { getOembedFromTikTokUrl, isValidTikTokUrl } from "../../tiptap/tiktok";
import { Markdown } from "@tiptap/markdown";
import { PasteMarkdown } from "../../tiptap/PasteMarkdown";

export default function tiptap(state, options) {
    let editor;

    return {
        state: state,
        updatedAt: Date.now(), // force Alpine to rerender on selection change
        ignoreStateUpdate: false,
        init() {
            const _this = this;

            editor = new Editor({
                element: _this.$refs.editor,
                content: _this.state,
                onCreate({ editor, event }) {
                    _this.updatedAt = Date.now();
                    _this.$dispatch("tiptap-create", event);
                },
                onUpdate({ editor, event }) {
                    _this.updatedAt = Date.now();

                    _this.ignoreStateUpdate = true;
                    _this.state = editor.getHTML();

                    _this.$dispatch("tiptap-update", event);
                },
                onSelectionUpdate({ editor, event }) {
                    _this.updatedAt = Date.now();
                    _this.$dispatch("tiptap-selection-update", event);
                },
                onBlur({ editor, event }) {
                    _this.$dispatch("tiptap-blur", event);
                },
                extensions: [
                    StarterKit.configure({
                        link: {
                            autolink: true,
                            openOnClick: false,
                            defaultProtocol: "https",
                            HTMLAttributes: {
                                rel: "noopener",
                            },
                        },
                    }),

                    Placeholder.configure({
                        ...options.placeholder,
                    }),
                    FileHandler.configure({
                        ...options.fileHandler,
                    }),
                    Image.configure({
                        allowBase64: false,
                        HTMLAttributes: {
                            loading: "lazy",
                        },
                        // resize: {
                        //     enabled: true,
                        //     alwaysPreserveAspectRatio: true,
                        //     minWidth: 50,
                        //     minHeight: 50,
                        // },
                    }),
                    Youtube.configure({
                        modestBranding: "true",
                        inline: false,
                        HTMLAttributes: {
                            style: "aspect-ratio: 16/9;width: 100%;height: auto;",
                        },
                    }),
                    CharacterCount.configure(),
                    TextAlign.configure({
                        types: ["heading", "paragraph"],
                    }),
                    TaskList.configure({
                        HTMLAttributes: {
                            class: "not-prose p-0",
                        },
                    }),
                    TaskItem.configure({
                        nested: false,
                        HTMLAttributes: {
                            class: "not-prose flex gap-2 items-center",
                        },
                    }),
                    Table.configure({
                        resizable: false,
                        HTMLAttributes: {
                            class: "table is-bordered is-striped is-fullwidth",
                        },
                    }),
                    TableRow,
                    TableHeader,
                    TableCell,
                    Tiktok,
                    Markdown,
                    PasteMarkdown,
                    ..._this.getBubbleMenus(),
                ],
                ...options.editor,
            });

            _this.$watch("state", (value, old) => {
                if (_this.ignoreStateUpdate) {
                    _this.ignoreStateUpdate = false;
                } else {
                    _this.editor().commands.setContent(value, {
                        emitUpdate: false,
                    });
                }
            });
        },
        getBubbleMenus() {
            const bubbleMenuTextElement = document.querySelector('[data-menu="bubbleMenuText"]');

            if (!bubbleMenuTextElement) {
                return [];
            }

            bubbleMenuTextElement.remove();

            return [
                BubbleMenu.configure({
                    pluginKey: "bubbleMenuText",
                    element: bubbleMenuTextElement,
                    tippyOptions: {
                        arrow: false,
                        duration: 100,
                        maxWidth: "none",
                        theme: "tiptap",
                    },
                    shouldShow: ({ editor, view, state, oldState, from, to }) => {
                        return (
                            editor.isEditable &&
                            isTextSelection(state.selection) &&
                            !state.selection.empty
                        );
                    },
                }),
            ];
        },
        /**
         * @returns {Editor}
         */
        editor() {
            return editor;
        },
        isActive(type, opts = {}) {
            return editor.isActive(type, opts);
        },
        async insertTiktokVideo(url) {
            if (!isValidTikTokUrl(url)) {
                return;
            }

            const oembed = await getOembedFromTikTokUrl(url);

            editor.commands.setTikTokVideo({
                url,
                blockquote: oembed.html,
            });
        },
        destroy() {
            editor.destroy();

            editor = null;
        },
    };
}
